import { Card, Row } from 'react-bootstrap'
import { convertDateWithTime } from '../../../../helpers/constants'
import StyledDetailField from './StyledDetailField'
import { cardStyle } from './DcDetailStyles'

const DcAuditInfo = ({ detail }) => {
  return (
    <Card style={cardStyle}>
      <Row>
        <StyledDetailField
          label="created by"
          value={!detail?.createdby ? '-' : detail?.createdby}
          col={3}
        />
        <StyledDetailField
          label="created at"
          value={
            !detail?.createdAt ? '-' : convertDateWithTime(detail?.createdAt)
          }
          col={3}
        />
        <StyledDetailField
          label="last updated by"
          value={!detail?.updatedby ? '-' : detail?.updatedby}
          col={3}
        />
        <StyledDetailField
          label="last updated at"
          value={
            !detail?.updatedAt ? '-' : convertDateWithTime(detail?.updatedAt)
          }
          col={3}
        />
      </Row>
    </Card>
  )
}

export default DcAuditInfo
